export default "__VITE_ASSET__BD$pgvrX__"